module.exports = "https://trybtryb-legacy.web.app/img/_heart.85e4b977.svg";